import { DataService } from "../../services/DataService";
import { _ROUTES } from "../../utils/_routes_constants";
import { _ACTIONS, _MESSAGES } from "../../utils/constants";
import { createToast } from "../../utils/toast";

const dataService = new DataService();

export const sendToFinancialData = (data, category, onSuccess = () => {}) => {
  dataService
    .doRequest(
      _ACTIONS.POST,
      _ROUTES.SAVE_FINANCIAL_DATA,
      {
        data: data,
        category: category,
      }
      
  )
    .then((response) => {
      createToast("success", _MESSAGES.saveSuccess);
      onSuccess(response);
    })
    .catch(() => {
      createToast("error", _MESSAGES.error);
    });
};

/**
 * When clicking on the save button, we send the data to the backend
 */
export const handleSaveDataSubmit = (
  gridRef,
  setSaveData,
  onSaveDataBefore = null,
) => {
  // Checks if grid reference exists
  if (gridRef.current && gridRef.current.api) {
    // Retrieves all data from the grid
    let rowData = [];
    gridRef.current.api.forEachNode((node) => {
      rowData.push(node.data);
    });
    // If there is a function to execute before saving the data, we execute it
    if (onSaveDataBefore) {
      rowData = onSaveDataBefore(gridRef, rowData);
    }

    // Sends data to the parent component
    setSaveData(rowData);
  } else {
    console.error("Grid reference not available");
  }
};


  // Fonction pour parser les nombres au format anglais
  export const parseEnglishNumber = (value) => {
    if (value === null || value === undefined || value === '') return null;
    
    // Convertir en string si ce n'est pas déjà le cas
    const strValue = String(value).trim();
    
    // Si c'est déjà un nombre valide, le retourner
    if (!isNaN(strValue) && strValue !== '') {
      return parseFloat(strValue);
    }
    
    // Supprimer les espaces et les virgules (séparateurs de milliers anglais)
    // puis remplacer le point par rien si c'est un séparateur de milliers
    // ou le garder si c'est le séparateur décimal
    let cleaned = strValue
      .replace(/\s/g, '') // Supprimer les espaces
      .replace(/,/g, ''); // Supprimer les virgules (milliers anglais)
    
    // Parser le nombre
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? null : parsed;
  };


  /**
 * Parse les nombres au format anglais (avec virgules comme séparateurs de milliers)
 * et au format français (avec espaces comme séparateurs de milliers)
 * Exemples:
 * - "1,234.56" -> 1234.56
 * - "1 234,56" -> 1234.56
 * - "1,234" -> 1234
 * - "1 234" -> 1234
 * - "123.45" -> 123.45
 * 
 * @param {string|number} value - La valeur à parser
 * @returns {number|null} - Le nombre parsé ou null si invalide
 */
export const parseInternationalNumber = (value) => {
  if (value === null || value === undefined || value === '') return null;
  
  // Convertir en string si ce n'est pas déjà le cas
  const strValue = String(value).trim();
  
  // Si c'est déjà un nombre valide, le retourner
  if (!isNaN(strValue) && strValue !== '') {
    return parseFloat(strValue);
  }
  
  // Détecter le format (anglais ou français) en cherchant le dernier séparateur
  const lastComma = strValue.lastIndexOf(',');
  const lastDot = strValue.lastIndexOf('.');
  
  let cleaned;
  
  if (lastComma > lastDot) {
    // Format français: virgule comme séparateur décimal
    cleaned = strValue
      .replace(/\s/g, '') // Supprimer les espaces
      .replace(/\./g, '') // Supprimer les points (milliers)
      .replace(',', '.'); // Remplacer virgule par point (décimal)
  } else {
    // Format anglais: point comme séparateur décimal
    cleaned = strValue
      .replace(/\s/g, '') // Supprimer les espaces
      .replace(/,/g, ''); // Supprimer les virgules (milliers)
  }
  
  // Parser le nombre
  const parsed = parseFloat(cleaned);
  return isNaN(parsed) ? null : parsed;
};

/**
 * Ajoute un valueParser aux colonnes de mois pour gérer les formats internationaux
 * @param {Array} columns - Les colonnes AG Grid
 * @param {Function} isMonthColumn - Fonction pour identifier une colonne de mois (optionnel)
 * @returns {Array} - Les colonnes avec valueParser ajouté
 */
export const enhanceColumnsWithParser = (columns, isMonthColumn = null) => {
  return columns.map((col) => {
    // Par défaut, considère qu'une colonne avec un field numérique est une colonne de mois
    const isMomentCol = isMonthColumn 
      ? isMonthColumn(col) 
      : !isNaN(parseInt(col.field, 10));
    
    if (isMomentCol) {
      return {
        ...col,
        valueParser: (params) => parseInternationalNumber(params.newValue),
      };
    }
    return col;
  });
};